<template>
  <div class="statementDetail">
    <div class="baseInfo">
      <div @click="foldBtn(1)" class="foldblock">
        <Icon :type="fold ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
        <span class="title">基本信息</span>
      </div>
      <Form ref="formValidate" :model="searchParams" :rules="ruleValidate" :label-width="130" class="form" v-show="fold">
        <FormItem label="对账单名称" prop="reconciliationName" :rules="$units.formRule.required('请输入对账单名称')">
          <Input v-model="searchParams.reconciliationName" placeholder="请输入对账单名称"></Input>
        </FormItem>
        <FormItem prop="reconciliationType" :rules="$units.formRule.required('请选择对账类型')">
          <span slot="label" class="label">
            对账类型
            <span class="tip-icon">?</span>
            <div class="pop-tip">
              <span>对账类型决定了从哪个对账池取要对账的数据，首年基础费用类型支持同时对账限时加费，续期基础费用类型支持同时对账续年服务津贴。</span>
              <div class="arrow"></div>
            </div>
          </span>
          <lzDicSelect v-model="searchParams.reconciliationType" dicType="RECONCILIATION_TYPE"
            @change="changeReconciliationType" :transfer="true">
          </lzDicSelect>
        </FormItem>
        <FormItem label="对账日期" prop="reconciliationDate" :rules="$units.formRule.objRequired('请选择对账日期')">
          <DatePicker transfer v-model="searchParams.reconciliationDate" format="yyyy-MM-dd" type="date"
            placeholder="请选择对账单日期">
          </DatePicker>
        </FormItem>
        <FormItem class="flex" label="供应商" prop="supplierId" :rules="$units.formRule.required('请选择供应商')">
          <Select v-model="searchParams.supplierType" placeholder="请选择供应商类型" @on-change="changeSupplierType">
            <Option value="1">保司</Option>
            <Option value="2">通道</Option>
          </Select>
          <Select class="m-4" v-model="searchParams.supplierId" placeholder="请选择供应商" clearable filterable @on-change="changeAgreement()">
            <Option :value="item.id" v-for="(item,index) in supplierList" :key="index">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="gradientConfigId" :rules="$units.formRule.required('请选择费用项名称')" v-if="searchParams.reconciliationType == 2">
          <span slot="label" class="label">
            费用项名称
            <span class="tip-icon">?</span>
            <div class="pop-tip">
              <span>上游费用配置内首年梯度加费的费用项名称</span>
              <div class="arrow"></div>
            </div>
          </span>
          <Select v-model="searchParams.gradientConfigId" clearable filterable placeholder="请选择费用项名称">
            <Option :value="item.id" v-for="(item, index) in gradientConfigList" :key="index">{{ 
              item.expenseItem }}</Option>
          </Select>
        </FormItem>
        <FormItem label="签约协议" prop="agreementId">
          <Select v-model="searchParams.agreementId" clearable filterable placeholder="请选择签约协议"
            @on-change="changeAgreementType">
            <Option :value="item.id" v-for="(item, index) in agreementList" :key="index">{{ item.covenantNo + '/' +
              item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="签约机构" prop="signOrgName">
          <Input v-model="searchParams.signOrgName" disabled placeholder="选择签约协议显示机构"></Input>
        </FormItem>
        <FormItem label="核收人" prop="reviewer">
          <Input v-model="searchParams.reviewer" placeholder="请输入核收人"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark" class="textarea">
          <Input type="textarea" v-model="searchParams.remark" :rows="4" placeholder="请输入备注信息" clearable />
        </FormItem>
      </Form>
    </div>
    <div class="policyData">
      <div @click="foldBtn(2)" class="foldblock">
        <Icon :type="foldData ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
        <span class="title">对账保单</span>
      </div>
      <div class="search-tools">
          <div class="search-box btn3">
            <div class="input-item">
              <span class="label">保单号</span>
              <Input v-model="searchData.policyNo" placeholder="请输入" clearable />
            </div>
            <Button type="primary" @click="getList()">搜索</Button>
          </div>
        </div>
      <div v-show="foldData">
        <div class="statistics-container">
          <div class="statistics-item">
            <span class="dot"></span>
            <span>系统保单数：</span>
            <span class="num">{{ summaryData.totalNumber || 0 }}</span>
          </div>

          <div class="statistics-item">
            <span class="dot"></span>
            <span>系统保费：</span>
            <span class="num">{{ summaryData.totalFee || 0 }}元</span>
          </div>

          <div class="statistics-item">
            <span class="dot"></span>
            <span>系统费用：</span>
            <span class="num">{{ summaryData.totalCommission || 0 }}元</span>
            <div
              v-if="searchParams.reconciliationType == 1 || searchParams.reconciliationType == 3">
              （
              <span>基础费用：</span>
              <span class="num" style="padding-right:10px">{{ summaryData.totalBaseCommission || 0 }}元</span>
              <span>限时加费：</span>
              <span class="num">{{ summaryData.totalActCommission || 0 }}元</span>
              ）
            </div>
          </div>
        </div>
        <div class="table-box">
          <div class="tools-box">
            <div class="left-box">
              <Checkbox v-model="isAll" @on-change="selectAll">全部</Checkbox>
            </div>
            <div class="right-box">
              <span class="text">已选择<span>{{ isAll ? total : ids.length }}</span>项,共<span>{{ total }}</span>记录</span>
            </div>
          </div>
          <loading :isShow="listLoading" />
          <Table :columns="columns" :data="tableData" @on-selection-change="selectionChange">
            <template slot-scope="{ row }" slot="action">
              <div class="detail">
                <div @click="deleteData(row)">
                  <span class="icon icon-remove"></span>
                  <span>删除</span>
                </div>
              </div>
            </template>
          </Table>
          <div class="pageBox">
            <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange"
              style="text-align: center" />
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <Button type="primary" @click="saveData" v-preventReClick>保存</Button>
      <Button type="primary" ghost @click="back(backUrl)">返回</Button>
      <Button type="primary" ghost @click.stop="nextStep()" :disabled="!tableData || tableData.length == 0">下一步</Button>
      <Dropdown trigger="click" :transfer="true" @on-click="dropdownClick($event)" style="margin-left:10px">
        <Button type="primary" ghost>
          选择要对账的保单
          <Icon type="ios-arrow-down" />
        </Button>
        <template #list>
          <DropdownMenu>
              <DropdownItem name="search">按条件检索数据</DropdownItem>
              <DropdownItem name="allSearch">输入保单号批量选择</DropdownItem>
          </DropdownMenu>
        </template>
      </Dropdown>
      <div v-if="searchParams.reconciliationType == 2">
        <Tooltip content="根据上游费用配置内该费用项的分档规则计算最终费用" placement="top" style="margin-left:10px">
          <Button type="primary" @click="compute" :disabled="!tableData || tableData.length == 0">计算</Button>
        </Tooltip>
      </div>
      <div v-else-if="searchParams.reconciliationType == 3">
        <Tooltip content="根据系统配置的该费用项的梯度加费分档规则计算最终费用" placement="top" style="margin-left:10px">
          <Button type="primary" @click="compute" :disabled="!tableData || tableData.length == 0">计算</Button>
        </Tooltip>
      </div>
      <div v-else-if="searchParams.reconciliationType == 4">
        <Tooltip content="根据上游继续率配置统计当前对账数据的产品继续率" placement="top" style="margin-left:10px">
          <Button type="primary" @click="openMonth" :disabled="!tableData || tableData.length == 0">计算继续率</Button>
        </Tooltip>
        <Tooltip content="根据上游费用配置的继续率系数计算续期费用，未配置的继续率系数为1" placement="top" style="margin-left:10px">
          <Button type="primary" @click="calculateCommission" :disabled="!tableData || tableData.length == 0">计算费用</Button>
        </Tooltip>
      </div>
      <div v-else-if="searchParams.reconciliationType == 5" style="margin-left:10px">
        <Tooltip content="根据上游继续率配置统计当前对账数据的产品继续率" placement="top" style="margin-left:10px">
          <Button type="primary" @click="openMonth" :disabled="!tableData || tableData.length == 0">计算继续率</Button>
        </Tooltip>
        <Tooltip content="根据继续率奖金配置计算继续率奖金，未配置的奖金为0" placement="top" style="margin-left:10px">
          <Button type="primary" @click="calculateCommission" :disabled="!tableData || tableData.length == 0">计算费用</Button>
        </Tooltip>
      </div>
      
      <Button type="primary" ghost @click="deleteStatement()" style="margin-left:10px">批量删除</Button>
      <Button type="primary" ghost @click="daochu()">导出系统清单</Button>
    </div>
    <Modal v-model="visible" :mask-closable="false" width="500" class="my-modal">
      <Form ref="form" :model="formData" label-position="top">
        <FormItem label="请选择需要启动计算的继续率月份" prop="date" :rules="$units.formRule.required('请选择月份')"
          style="margin-top: 30px;">
          <DatePicker transfer :value="formData.date" @on-change="formData.date = $event" format="yyyy-MM" type="month"
            placeholder="请选择"></DatePicker>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer" slot="footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="compute">确定</Button>
      </div>
    </Modal>
    <getStatementModel ref="getStatementModel" @getList="getList();detail()"></getStatementModel>
    <selectSettlementData ref="selectSettlementData" :supplierId = "searchParams.supplierId" :reconciliationType="searchParams.reconciliationType" @getList="getList();detail()"></selectSettlementData>
  </div>
</template>

<script>
import { pageTool,common } from "@/api/mixins";
import { config } from './statementDetail.js';
import getStatementModel from "./getStatementModel.vue";
import selectSettlementData from './selectSettlementData.vue';
import lzDicSelect from "@/components/commons/lzDicSelect";
import filter from "@/api/filter";
export default {
  components: { getStatementModel, lzDicSelect,selectSettlementData },
  props: ['id'],
  mixins: [pageTool, config,common],
  data() {
    return {
      fold: true,
      foldData: true,
      isAll: false,
      visible: false,
      pageNo: 1,
      agreementList: [],
      gradientConfigList:[],
      ruleValidate: {},
      searchData:{},
      backUrl: '', //返回链接
      ids: [],
      formData: {
        date: ''
      },
      summaryData: {
        totalNumber: '',
        totalFee: '',
        totalFeePremiums: '',
        totalFeeNonPremiums: '',
        totalCommission: ''
      },// 系统汇总数据
      searchParams: {
        reconciliationType: '1',
        supplierType: '1',
        reconciliationDate: filter.filterTime(new Date(), "YYYY-MM-DD"),
        signOrgName:''
      },
      supplierList: [],
      tableData: [],
      columns: [],
    }
  },
  mounted(){
    this.backUrl = this.$route.query.backUrl;
    this.getAgreementType()
    if (this.$route.query.id) {
      this.detail()
      this.getList()
    }else{
      this.changeSupplierType(this.searchParams.supplierType)
    }
    this.getColumns()
  },
  methods: {
    daochu() {
      if(!this.tableData.length){
        this.$notice.error('无可导出数据');
        return
      }
      if(this.$units.pointAction('offline_8_1_5')){
        this.loading = true;
        this.$http({
          url: "/buz/molCommissionConsult/exportByCheckId",
          type: "POST",
          responseType: "blob",
          data: {
            checkId: this.$route.query.id || this.searchParams.id,
            policyNo:this.searchData.policyNo,
          },
        })
          .then((res) => {
            this.loading = false;
            this.$units.daochu(res);
          })
          .catch((e) => {
            this.loading = false;
          });
        }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    changeAgreement(){
      this.searchParams.agreementId=''
      this.getAgreementType()
      if(this.searchParams.id){
        this.emptyPolicy()
      }
    },
    emptyPolicy(){
      this.$http({
        url: `/buz/commissionReconciliation/clearPolicy`,
        type: "GET",
        data: {
          id: this.$route.query.id || this.searchParams.id,
         }
      }).then((res) => {
        this.getList()
      })
    },
    // 更多操作
    dropdownClick(name, row) {
      if (name == 'search') {
        this.saveData('openStatement')
      } else if (name == 'allSearch') {
        this.saveData('selectSettlementData')
      }
    },
    // 获取费用项
    getGradientConfigList(id) {
      this.$http({
        url: `/buz/commissionReconciliation/queryGradientList`,
        type: "GET",
        data: {
          supplierType:this.searchParams.supplierType,
          supplierId:this.searchParams.supplierId,
          policyType:1
         }
      }).then((res) => {
        this.gradientConfigList = res.data;
      })
    },
    changeReconciliationType() {
      this.getColumns()
      if (this.$route.query.id || this.searchParams.id) {
        this.$http({
          url: '/buz/commissionReconciliation/jumpBack',
          type: 'POST',
          data: {
            id: this.$route.query.id || this.searchParams.id,
            reconciliationType:this.searchParams.reconciliationType
          },
        }).then(() => {
          this.detail()
          this.getList()
        })
      }
    },
    openMonth() {
      if(this.$units.pointAction('offline_8_1_2')){
        if (this.searchParams.reconciliationType == 4 || this.searchParams.reconciliationType == 5) {
          this.$refs.form.fields.forEach(item => {
            item.validateState = '';
            item.validateMessage = '';
          });
          this.formData = {
            date: ''
          }
          this.visible = true
        } else {
          this.compute()
        }
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    calculateCommission(){
      if(this.$units.pointAction('offline_8_1_2')){
        if(this.searchParams.computeRate==0){
          let msg
          if(this.searchParams.reconciliationType == 4){
            msg = '还未计算继续率，继续率默认为1，请确认是否计算续期费用？'
          }else if(this.searchParams.reconciliationType == 5){
            msg = '还未计算继续率，继续率奖金可能为0，请确认是否计算？'
          }

          this.$notice.inquiry(msg).then(async () => {
            this.compute()
          })
        }else{
          this.compute()
        }
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    compute() {
      if(this.$units.pointAction('offline_8_1_2')){
        let data = {}
        if (this.visible) {
          this.$refs.form.validate(valid => {
            if (valid) {
              let year = this.formData.date.split('-')[0]
              let month = this.formData.date.split('-')[1]
              data = {
                checkId: this.$route.query.id ? this.$route.query.id : this.searchParams.id,
                supplierType:this.searchParams.supplierType,
                supplierId:this.searchParams.supplierId,
                year: year,
                month: month
              }

              this.$http({
                url: `/buz/molCommissionConsult/computeContinueRate`,
                type: "POST",
                data: data
              }).then((res) => {
                this.visible = false
                this.getList()
                this.detail()
                this.$notice.success("操作成功");
              })
            }
          })
        } else {
          data = {
            checkId: this.$route.query.id ? this.$route.query.id : this.searchParams.id,
          }
          this.$http({
            url: `/buz/molCommissionConsult/computeCommission`,
            type: "POST",
            data: data
          }).then((res) => {
            this.getList()
            this.detail()
            this.$notice.success("操作成功");
          })
        }
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.ids = [];
    },
    // 获取列表数据
    getList() {
      this.listLoading = true;
      this.$http({
        url: "/buz/molCommissionConsult/queryPageByCheckId",
        type: "post",
        data: {
          checkId: this.$route.query.id ? this.$route.query.id : this.searchParams.id,
          policyNo:this.searchData.policyNo,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
      }).then(res => {
        res.data.forEach(item => {
          this.ids.forEach(item2 => {
            if (item.id == item2) {
              item._checked = true;
            }
          })
          if (this.isAll) {
            item._checked = true;
            item._disabled = true;
          }
        })
        this.tableData = res.data;
        this.total = res.total;
        this.getSummaryData()
      }).finally(e => {
                    this.listLoading = false;
                });
    },
    // 批量删除
    deleteStatement() {
      if(this.$units.pointAction('offline_8_1_2')){
        if (this.ids && this.ids.length > 0 || this.isAll) {
          this.$notice.inquiry("请确认是否删除？").then(async () => {
            this.$http({
              url: `/buz/molCommissionConsult/batchDel`,
              type: "POST",
              data: {
                checkId: this.$route.query.id ? this.$route.query.id : this.searchParams.id,
                ids: this.ids,
                isAll: this.isAll
              }
            }).then((res) => {
              this.ids = [];
              this.visible = false
              this.isAll = false
              this.getList()
            })
          });
        } else {
          this.$notice.msg("请至少选择一个保单")
        }
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 单个删除
    deleteData(item) {
      if(this.$units.pointAction('offline_8_1_2')){
        this.$notice.inquiry("请确认是否删除？").then(async () => {
          this.$http({
            url: '/buz/molCommissionConsult/del',
            type: 'get',
            data: {
              id: item.id,
            },
          }).then((res) => {
            this.$notice.success("操作成功");
            this.pageNo = 1;
            this.getList()
          })
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    selectionChange(rows) {
      const pageIds = rows.map(item => item.id); //当前页勾选的
      const selectIds = this.ids.map(item => item); //已经添加的数据
      this.tableData.forEach(item => {
        if (pageIds.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.ids.push(item.id);
          selectIds.push(item.id);
        } else if (!pageIds.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.ids.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
    //获取汇总数据
    getSummaryData() {
      this.$http({
        url: '/buz/molCommissionConsult/queryPageByCheckId/summaryData',
        type: 'POST',
        data: {
          checkId: this.$route.query.id ? this.$route.query.id : this.searchParams.id,
          policyNo:this.searchData.policyNo,
        },
      }).then((res) => {
        if (res.data) {
          this.summaryData = res.data
        }
      })
    },
    detail() {
      this.$http({
        url: "/buz/commissionReconciliation/read/detail",
        type: "GET",
        data: { id: this.$route.query.id ? this.$route.query.id : this.searchParams.id},
      }).then((res) => {
        this.searchParams = res.data
        this.searchParams.reconciliationType = res.data.reconciliationType ? res.data.reconciliationType : '1'
        this.searchParams.reconciliationDate = res.data.reconciliationDate ? filter.filterTime(res.data.reconciliationDate, "YYYY-MM-DD") : filter.filterTime(new Date(), "YYYY-MM-DD")
        this.setPageTitle(this.searchParams.reconciliationName)
        this.changeSupplierType(this.searchParams.supplierType)
        this.getColumns()
      });
    },
    saveData(item) {
      if(this.$units.pointAction('offline_8_1_2')){
        delete this.searchParams.agreementName
        this.searchParams.reconciliationDate = this.searchParams.reconciliationDate ? filter.filterTime(this.searchParams.reconciliationDate, "YYYY-MM-DD") : ''
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            let url
            if (this.searchParams.id) {
              url = "/buz/commissionReconciliation/edit"
            } else {
              url = "/buz/commissionReconciliation/add"
            }
            this.$http({
              url: url,
              type: "POST",
              data: this.searchParams,
            }).then((res) => {
              this.searchParams.id = res.data.id
              if (item == 'openStatement') {
                this.$emit('changeCheckId', res.data.id)
                this.$refs.getStatementModel.open(this.searchParams.id)
              }else if(item == 'selectSettlementData'){
                this.$emit('changeCheckId', res.data.id)
                this.$refs.selectSettlementData.open(this.searchParams)
              }
              else{
                this.$notice.success("保存成功");
              }
              if(this.searchParams.id){
                this.detail()
              }
              
            });
          }else{
            window.setTimeout(()=>{
              window.scrollTo(0, 0)
            },300)
          }
        });
      }else{
          this.$Message.error('无权操作，请联系您的上级')
        }
    },
    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getList()
    },
    nextStep() {
      if(this.$units.pointAction('offline_8_1_2')){
        let msg
        if(this.searchParams.reconciliationType == 2){
          msg = '尚未根据梯度加费分档规则计算最终费用，可能导致大量对比异常，是否继续？'
        }else if(this.searchParams.isCompute == 0){
          msg = '尚未根据上游费用配置计算费用，可能导致大量对比异常，是否继续？'
        }
        if (this.searchParams.reconciliationType != 1 && this.searchParams.isCompute == 0 && this.searchParams.reconciliationType != 3) {
          this.$notice.inquiry(msg).then(async () => {
            this.$http({
              url: '/buz/commissionReconciliation/edit',
              type: 'POST',
              data: {
                step: 2,
                id: this.searchParams.id,
                agreementId:this.searchParams.agreementId
              },
            }).then((res) => {
              this.$emit('nextStep')
            })
          })
        } else {
          this.$http({
            url: '/buz/commissionReconciliation/edit',
            type: 'POST',
            data: {
              step: 2,
              id: this.searchParams.id,
              agreementId:this.searchParams.agreementId
            },
          }).then((res) => {
            this.$emit('nextStep')
          })
        }
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }

    },
    // 改变协议类型
    changeAgreementType() {
      if (this.searchParams.agreementId) {
        this.agreementList.forEach((res) => {
          if (res.id == this.searchParams.agreementId) {
            this.$set(this.searchParams,'signOrgName',res.signOrgName)
            console.log(this.searchParams.signOrgName);
          }
        })
      } else {
        this.searchParams.signOrgName = ''
      }
    },
    getAgreementType() {
      let data
      if(this.searchParams.supplierId){
        data = {
          insuranceSupplierType: this.searchParams.supplierType,
          insuranceSupplierId: this.searchParams.supplierId,
          pageSize: 1000,
          pageNo: 1,
        }
      }else{
        data = {
          pageSize: 1000,
          pageNo: 1,
        }
      }
      
      this.$http({
        url: '/buz/covenant/read/list',
        type: 'POST',
        data: data
      }).then((res) => {
        this.agreementList = res.data;
        this.getGradientConfigList()
        this.changeAgreementType()
      })
    },
    // 切换供应商类型
    changeSupplierType(value) {
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all'
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list'
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
    },
    // 展开收起
    foldBtn(val) {
      if (val == 1) {
        this.fold = !this.fold
      } else {
        this.foldData = !this.foldData
      }
    }
  }
}
</script>

<style lang="scss" scoped>@import './statementDetail.scss';</style>